import { cacheDom } from '../utils/QuerySelectors.js'

const dom = {}
const qs = {
  section: 'data-section-type="years-diagram"',
}
const qsAll = {
  tiles: 'data-year-tile',
  swipers: 'data-year-media-swiper',
}

const activateTile = (tile) => {
  dom.tiles.forEach((t) => t.classList.remove('year-tile--active'))
  tile.classList.add('year-tile--active')
}
export const setupYearsDiagram = () => {
  cacheDom(dom, qs, qsAll)
  if (dom.section) {
    dom.tiles.forEach((tile) => {
      tile.addEventListener('click', () => {
        activateTile(tile)
      })
      tile.addEventListener('focus', () => {
        activateTile(tile)
      })
    })
    dom.swipers.forEach((swiper) => {
      new Swiper(swiper, {
        direction: 'vertical',
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          slidesPerView: 'auto',
        },
        breakpoints: {
          320: {
            direction: 'horizontal',
            slidesPerView: 'auto',
            spaceBetween: 8,
          },
          1024: {
            direction: 'vertical',
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
      })
    })
  }
}
